require('./policies.style.scss');
const { permissions } = require('../../constants/permissions');
const Policy = require('../../model/Policy');
const POLICIES_PROGRESS_CLASS = [
    { status: 'compliant', class: 'progress-bar-compliant' },
    { status: 'uncompliant', class: 'progress-bar-uncompliant' },
];

class PoliciesController {
    constructor($scope, $element, $filter, $stateParams, $timeout, $rootScope, storageService, policiesPersistence, utilsService, dialogService, notificationService, policiesUtils, iamPersistenceService) {
        this.$scope = $scope;
        this.$element = $element;
        this.$filter = $filter;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.storageService = storageService;
        this.persistence = policiesPersistence;
        this.iamPersistenceService = iamPersistenceService;
        this.utilsService = utilsService;
        this.dialogService = dialogService;
        this.notificationService = notificationService;
        this.policiesUtils = policiesUtils;
        this.details = [
            { name: 'vms', title: this.$filter('translate')('policy.subTable.detail.vms.title') },
        ];

        this.configPoliciesTable();

        this.$scope.$on('sub-changed', () => {
            this.load(true, true);
        });

        this.isMini = false;

    }

    configPoliciesTable() {
        this.policyTableConfig = [
            { name: this.$filter('translate')('policy.table.header.name'), key: 'name' },
            { name: this.$filter('translate')('policy.table.header.compliancyStatus'), key: 'compliancyStatus' },
            { name: this.$filter('translate')('policy.table.header.vmsCount'), key: 'vmsCount' },
            { name: this.$filter('translate')('policy.table.header.description'), key: 'description' },
            { name: this.$filter('translate')('policy.table.header.isDefault'), key: 'isDefault' },
        ];
    }

    $onInit() {
        this.selectedPolicies = [];
        this.filterFlag = 0;
        this.stateParamsFilterInit();
        this.load(true, true);
        this.filterFlag++;

        this.destroyBroadcastCatcher = this.$rootScope.$on("subscriptionChanged", () => {
            this.load(true, true);
        });
    }

    $onDestroy() {
        this.destroyBroadcastCatcher();
    }

    stateParamsFilterInit() {
        let stateFilter,
            stateParam = this.$stateParams.statusFilter ? this.$stateParams.statusFilter : this.$stateParams.compliantFilter;
        if (!stateParam) return;

        this.persistence.clearFilter();
        stateFilter = this.persistence.filters.filter(item => item.filterKey === Policy.getCompliancyKey())[0];
        stateFilter.setOptionByValue(stateParam);
    }

    refresh(firstPage) {
        this.load(firstPage);
    }

    getPoliciesOnCloseDialog(policy) {
        this.load(false, false, false, policy);
    }

    load(firstPage, firstLoad, clearSelection, savedPolicy) {
        this.busy = true;
        if (clearSelection) {
            this.shownDetailsIndex = false;
            this.selectedPolicies = [];
        }
        return this.persistence.getPolicies(firstPage).then(policies => {
            this.policies = !policies ? [] : policies;
            if (savedPolicy) {
                this.selectedPolicies = this.policies.filter(p => p.name === savedPolicy.name);
                if (!this.selectedPolicies[0]) {
                    this.shownDetailsIndex = false;
                    return;
                }
                this.selectedPolicies[0]._selected = true;
                this.showDetails(this.selectedPolicies[0], false);
            } else {
                if (firstLoad && this.policies.length) {
                    this.$timeout(() => {
                        this.policies[0]._selected = true;
                        this.selectedPolicies[0] = this.policies[0];
                        this.showDetails(this.policies[0]);
                    }, 0);
                } else if (this.selectedPolicies && this.selectedPolicies[0]) {
                    this.$timeout(() => {
                        this.selectedPolicies = this.policies.filter(policy => policy.uuid === this.selectedPolicies[0].uuid);
                        if (!this.selectedPolicies[0]) {
                            this.shownDetailsIndex = false;
                            return;
                        }
                        this.selectedPolicies[0]._selected = true;
                        this.showDetails(this.selectedPolicies[0]);
                    }, 0);
                }
            }
            this.defaultIsSet = this.policies.filter(item => item.isDefault);
            this.busy = false;
        }, err => {
            this.busy = false;
            this.policies = [];
            this.selectedPolicies = [];
            this.shownDetailsIndex = false;
        });
    }

    isReadOnly(policy) {
        return angular.isDefined(policy) ? policy.readOnly : null;
    }

    isOkRpo(policy) {
        return angular.isDefined(policy) ? policy.rpo >= (24 * 60) : null;
    }

    getPolicyByName(name) {
        return this.policies.filter(policy => policy.name == name)[0];
    }

    del() {
        let notice = null;
        if (this.selectedPolicies[0].virtualMachinesCount > 0) {
            notice = this.$filter('translate')('policy.dialog.deleteDialog.warning.notice', { name: this.selectedPolicies[0].name });
        }
        this.dialogService.showYesNo(
            this.$filter('translate')('policy.deleteDialog.text', { name: this.selectedPolicies[0].name }),
            this.$filter('translate')('policy.deleteDialog.title'),
            notice,
            'policies-delete')
            .then(result => {
                if (!result) return false;
                this.grid.selectedItems = undefined;
                return this.removePolicy(this.selectedPolicies[0]);
            }).then(() => {
            }, err => this.err = err);
    }

    removePolicy(policy) {
        this.busy = this.persistence.deletePolicy(policy).then(resp => {
            this.load(false, true, true);
            this.notificationService.pop(resp.data.message);
            this.showDetails();
        }, err => {
        });
    }

    getDetailedPolicyName(policy) {
        this.detailedGroupName = policy.name;
    }

    showDetails(item) {
        item.name !== 'Exclude' ? this.busyDetails = true : this.busyDetails = false;
        if (!item || item.name === 'Exclude') {
            this.busyDetails = false;
            this.shownDetailsUUID = false;
            return;
        }
        this.selectedPolicyName = item.name;
        this.shownDetailsUUID = item && item._selected ? item.uuid : false;
        if (this.shownDetailsUUID && this.iamPersistenceService.hasPermissions(permissions.POLICY_DETAILS)) {
            this.persistence.getPolicy(this.shownDetailsUUID).then(resp => {
                const policy = resp.data.entities[0];
                this.getDetailedPolicyName(policy);
                this.setPolicyDetails(Policy.fromRaw(policy));
                this.setPolicyBarCahrts(Policy.fromRaw(policy));
                this.busyDetails = false;
                this.selectedPolicies[0] = policy;
            }, err => {
                this.busyDetails = false;
            });
        } else {
            this.isMini = false;
            this.busyDetails = false;
        }
    }

    setPolicyDetails(policy) {
        this.setDetailsList(policy);
        if (policy.tags) {
            for (let i = 0; i < policy.tags.length; i++) {
                policy.tags[i].name_formatted = policy.tags[i].name.length > 15 ? policy.tags[i].name.slice(0, 15) + '...' : policy.tags[i].name;
                policy.tags[i].value_formatted = policy.tags[i].value.length > 15 ? policy.tags[i].value.slice(0, 15) + '...' : policy.tags[i].value;
            }
        }
    }

    setDetailsList(policy) {
        const cronTime = this.policiesUtils.calculateRtoRpoTime(policy.intervalInMinutes);
        const backupRetentionTime = this.policiesUtils.calculateRetentionTime(policy.backupRetention);
        const copyRetentionTime = this.policiesUtils.calculateRetentionTime(policy.copyRetention);
        this.policyDetails = [
            {
                detail: this.$filter('translate')('policy.subTable.detail.uuid.label'),
                value: policy.uuid,
                icon: 'icon-copy',
                id: 'policy-uuid'
            },
            {
                detail: this.$filter('translate')('policy.subTable.detail.backup.title'),
                subSectionTitle: true
            },
            {
                detail: this.$filter('translate')('policy.subTable.detail.rpo.label'),
                tooltip: this.$filter('translate')('policy.edit.form.rpo.description'),
                value: this.policiesUtils.readRtoRpo(policy.intervalInMinutes, cronTime) + ' ' + cronTime.toLowerCase(),
                subSection: true
            },
            {
                detail: this.$filter('translate')('policy.subTable.detail.backupRetention.label'),
                value: this.policiesUtils.readRetention(policy.backupRetention, backupRetentionTime) + ' ' + backupRetentionTime.toLowerCase(),
                subSection: true
            },
            {
                detail: this.$filter('translate')('policy.subTable.detail.copyRetention.label'),
                value: policy.copyRetention ? this.policiesUtils.readRetention(policy.copyRetention, copyRetentionTime) + ' ' + copyRetentionTime.toLowerCase() : 'N/A',
                subSection: true
            },
            {
                detail: this.$filter('translate')('policy.subTable.detail.targetName.label'),
                value: policy.targetName,
                subSection: true
            },
            {
                detail: this.$filter('translate')('policy.subTable.detail.tier.label'),
                value: (policy.tier === 'TIER_FREE') ? 'Free' : this.utilsService.enumToNiceString(policy.tier),
                subSection: true
            },
            {
                detail: this.$filter('translate')('policy.subTable.detail.backupWindow.label'),
                value: policy.backupWindowName,
                subSection: true
            },
            {
                detail: this.$filter('translate')('policy.subTable.detail.gibibytesMonths.label'),
                tooltip: this.$filter('translate')('policy.subTable.detail.gibibytesMonths.description'),
                value: this.utilsService.fromBytesTo(policy.estimatedConsumptionInBytes, 'gib') + ' GiB/Months',
                subSection: true
            },
            {
                detail: this.$filter('translate')('policy.subTable.detail.archive.label'),
                value: policy.archiveName,
                subSection: true
            },
        ];

    }

    setPolicyBarCahrts(policy) {
        this.details[0].total = policy.vmsCount;
        this.details[0].items = [
            {
                status: 'compliant',
                value: policy.compliantVirtualMachineCount,
                compliantFilter: 'GREEN',
                percentageValue: Math.round(policy.compliantVirtualMachineCount * 100 / policy.vmsCount) + '%',
                title: 'Compliant = ' + policy.compliantVirtualMachineCount + ' (' + Math.round(policy.compliantVirtualMachineCount * 100 / policy.vmsCount) + '%)'
            },
            {
                status: 'uncompliant',
                value: policy.uncompliantVirtualMachineCount,
                compliantFilter: 'RED',
                percentageValue: Math.round(policy.uncompliantVirtualMachineCount * 100 / policy.vmsCount) + '%',
                title: 'Non-compliant = ' + policy.uncompliantVirtualMachineCount + ' (' + Math.round(policy.uncompliantVirtualMachineCount * 100 / policy.vmsCount) + '%)'
            }
        ];

        this.setPoliciesStyle();
    }

    setPoliciesStyle() {
        this.details.forEach(d => {
            for (let i in d.items) {
                d.items[i].class = POLICIES_PROGRESS_CLASS.filter(p => p.status === d.items[i].status)[0].class;
                i > 0 ? d.items[i].style = this.setProgressBarWidth(d.items[i].percentageValue) || { width: 0 } : d.items[i].style = { width: d.items[i].percentageValue || 0 };
            }
        });
    }

    setProgressBarWidth(width) {
        let margin = '2px';
        return parseInt(width) < 100 ? {
            'margin-left': margin,
            'width': 'calc(' + width + ' - ' + margin + ')'
        } : { width: width || 0 };
    }

    filterRefresh() {
        this.selectedPolicies = [];
        this.shownDetailsUUID = false;
        this.load(true, null, true);
        this.filterFlag++;
    }

    setGrid(grid) {
        this.grid = grid;
        this.ctxGridStyleConfig = {
            multiselect: false,
            columnsWidthMapInPct: []
        };
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('28%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('10%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('12%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('50%');
        // this.ctxGridStyleConfig.columnsWidthMapInPct.push('10%');
        this.$timeout(() => {
            this.grid.tableName = this.grid.tableName + '-' + this.storageService.getUsername();
            if (angular.isDefined(this.storageService.getGridWolumnsWidthMapInPct(this.grid.tableName))) {
                this.ctxGridStyleConfig.columnsWidthMapInPct = this.storageService.getGridWolumnsWidthMapInPct(this.grid.tableName);
            }
            this.gridColumnsStyleConfig = this.ctxGridStyleConfig;
            this.gridFlag = true;
        }, 0);
    }

    openBackupWindowDialog() {
        this.showBackupWindow = true;
    }

    openPolicyAddDialog() {
        this.policyToEdit = null;
        this.isEditMode = false;
        this.showPolicyAddEditDialog = true;
    }

    openPolicyEditDialog() {
        this.policyToEdit = this.selectedPolicies[0];
        this.isEditMode = true;
        this.showPolicyAddEditDialog = true;
    }

    openArchivingDialog() {
        this.showArchiving = true;
    }

    setDefault() {
        this.dialogService.showYesNo(this.$filter('translate')('policy.isDefault.vmsAndShares.text'), this.$filter('translate')('policy.isDefault.title'), null, 'policies-set-default', true)
            .then(res => {
                if (!_.isUndefined(res)) {
                    return this.persistence.setDefaultPolicy(this.selectedPolicies[0], res)
                        .then(resp => { this.notificationService.pop(resp.data.message); })
                        .finally(() => { this.load(); });
                }
            });
    }

    resetDefault() {
        return this.persistence.resetDefaultPolicy().then(resp => {
            this.load();
            this.notificationService.pop(resp.data.message);
        });
    }

    onExport(type) {
        this.busy = true;
        return this.persistence[type === 'all' ? 'getAllPolicies' : 'getPolicies'](type === 'all', { isExport: true }).then(res => {
            return res.map(item => {
                let result = {};
                result['name'] = item.name;
                result['compliancyStatus'] = !item.compliancyStatus ? '' : item.compliancyStatus;
                result['vmsCount'] = item.vmsCount;
                result['description'] = item.description;
                return result;
            });
        }).finally(() => {
            this.busy = false;
        });
    }

    isCreatePolicyDisabled() {
        return !this.hasCreatePolicyPermissions();
    }

    isUpdatePolicyDisabled() {
        return !this.hasUpdatePolicyPermissions() || !this.selectedPolicies || !this.selectedPolicies.length || this.isReadOnly(this.selectedPolicies[0]);
    }

    isDeletePolicyDisabled() {
        return !this.hasDeletePolicyPermissions() || !this.selectedPolicies || !this.selectedPolicies.length || this.isReadOnly(this.selectedPolicies[0]);
    }

    isSetDefaultDisabled() {
        return !this.hasSetDefaultPermissions() || !this.selectedPolicies || !this.selectedPolicies.length || this.selectedPolicies[0].isDefault;
    }

    isClearDefaultDisabled() {
        return !this.hasSetDefaultPermissions();
    }

    hasPoliciesListingPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.POLICY_LISTING);

    }

    hasPoliciesDetailsPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.POLICY_DETAILS);
    }

    hasDeletePolicyPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.POLICY_DELETE);
    }

    hasUpdatePolicyPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.POLICY_UPDATE);
    }

    hasCreatePolicyPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.POLICY_CREATE);
    }

    hasSetDefaultPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.DEFAULT_POLICY_SET);
    }
}

PoliciesController.$inject = ['$scope', '$element', '$filter', '$stateParams', '$timeout', '$rootScope', 'storageService', 'policiesPersistence', 'utilsService', 'dialogService', 'notificationService', 'policiesUtils', 'iamPersistenceService'];

const policiesComponent = {
    controller: PoliciesController,
    template: require('./policies.template.html')
};

module.exports = policiesComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/policies/policies.component.js